export default __webpack_public_path__ + "assets/f06670.svg";